import React from "react";
import ReactDOM from "react-dom";
import { App, AppProps } from "./app";
import "./styles/index.scss";

export * from "./portal/appRoutes";

export * from "./portal/dashboard";

export function renderSpa(e: Element, props: AppProps) {
  ReactDOM.render(
    <React.StrictMode>
      <App
        baseUrl={props.baseUrl || ""}
        apiPortal={props.apiPortal || ""}
        identityUrl={props.identityUrl || ""}
        postLogoutUrl={props.postLogoutUrl || ""}
        b2cDomainName={props.b2cDomainName || ""}
        b2cClientId={props.b2cClientId || ""}
        endSessionEndpoint={props.endSessionEndpoint || ""}
      />
    </React.StrictMode>,
    e
  );
}
